import moment from 'moment-timezone';
import { cloneDeep } from 'lodash';
import instance from './common';

function getFilter4UserTimeline(viewerId, clientId) {
  const res: {
    field: string;
    key?: any;
    op: string;
    value?: string;
    display: string;
    originalField?: string;
    _order?: number;
  }[][] = [
    [
      {
        field: 'event_name',
        key: null,
        op: 'not_eq',
        value: 'conviva_page_ping',
        display: 'conviva_page_ping',
        originalField: 'event_name',
        _order: 0,
      },
    ],
    [
      {
        field: 'event_name',
        key: '',
        op: 'not_eq',
        value: 'conviva_periodic_heartbeat',
        display: 'conviva_periodic_heartbeat',
        originalField: 'event_name',
        _order: 0,
      },
    ],
  ];
  if (viewerId) {
    res.push([
      {
        display: viewerId,
        field: 'app_user_id',
        op: 'eq',
      },
    ]);
  }
  if (clientId) {
    res.push([
      {
        display: clientId,
        field: 'client_id',
        op: 'eq',
      },
    ]);
  }
  return res;
}

export interface ISessionTimelineSummaryDataItem {
  name: string;
  value: string | number;
}

export interface ISessionTimelineSummaryData {
  userInfoData: ISessionTimelineSummaryDataItem[];
  eventSummaryData: ISessionTimelineSummaryDataItem[];
}

export interface ISessionTimelineTableDataItem {
  sessionId: string;
  eventTimeStampStart: string;
  eventTimeStampEnd: string;
  userActiveTime: number;
  appCrashes: number;
  noOfFailedReq: number;
  totalEvents: number;
  index: number | string;
  inSession: number | string;
}

export interface UserTimelineEvent {
  derivedTstamp: string;
  sessionId: string;
  inSession: 0 | 1;
  eventName: string;
  /** not exist for App Scaled */
  sessionDuration: string;
  eventAttributes: object | {};
  // [props: string]: number | string | object;
}

export interface CombinationFilterItem {
  type: string;
  rel: string;
  combinations: Array<ExpressionFilterItem | CombinationFilterItem>;
}

export interface ExpressionFilterItem {
  op: string;
  val: string;
  type: string;
  field: string;
}

export interface MetricFilter {
  dimension: string;
  lower?: string;
  upper?: string;
  type: 'bound';
}

export interface MarioQuery {
  project: string;
  query_id: string | number;
  with_total?: boolean;
  model: string;
  explore: string;
  fields: string[];
  filters?: CombinationFilterItem | ExpressionFilterItem;
  sorts?: string[];
  limit?: number;
  query_timezone: string;
  parameters?: Array<Record<string, any>>;
  metricFilter?: MetricFilter;
  drill_down_filters?: CombinationFilterItem | ExpressionFilterItem;
  options?: object;
}

export const getAppDataTimeline = (
  reqBody,
  options: {
    viewerId: string;
    ts: string;
    clientId: string | null;
  },
  http = instance,
) => {
  const queries = cloneDeep(reqBody.queries);
  const { viewerId, ts, clientId } = options;
  const now = new Date();
  const last = new Date(now.getTime() - 24 * 3600000);
  const interval = ts || `${moment(last)}/${moment(now)}`;

  return http.post<{
    summaryData: ISessionTimelineSummaryData;
    sessionTableData: ISessionTimelineTableDataItem[];
  }>('/appData/timeline', {
    queries: queries.map((q) => {
      return {
        ...q,
        metrics: [],
        type: '',
        interval,
        granularity: 'ALL',
        filter: getFilter4UserTimeline(viewerId, clientId),
      };
    }),
  });
};
export const getAppDataTimelineEventList = (
  reqBody,
  options: {
    viewerId: string;
    ts: string;
    clientId: string | null;
    sessionId: string;
    enableNW: boolean;
  },
  http = instance,
) => {
  const queries = cloneDeep(reqBody.queries);
  const { viewerId, ts, clientId, sessionId, enableNW } = options;
  const now = new Date();
  const last = new Date(now.getTime() - 24 * 3600000);
  const interval = ts || `${moment(last)}/${moment(now)}`;
  const filter = getFilter4UserTimeline(viewerId, clientId);
  filter.push([
    {
      field: 'session_id',
      display: sessionId,
      op: 'eq',
    },
  ]);
  if (!enableNW) {
    filter.push([
      {
        field: 'event_name',
        display: 'conviva_network_request',
        op: 'not_eq',
      },
    ]);
  }
  return http.post<{
    eventList: UserTimelineEvent[];
    requestBody: MarioQuery;
  }>('/appData/timeline/eventList', {
    queries: queries.map((q) => {
      return {
        ...q,
        metrics: [],
        type: '',
        interval,
        granularity: 'ALL',
        filter,
      };
    }),
  });
};
export const queryAppData = (body, opts) => instance.post('/metrics', { queries: body }, opts);
